import { render, staticRenderFns } from "./topChartAndTable.vue?vue&type=template&id=0840fae0&scoped=true&"
import script from "./topChartAndTable.vue?vue&type=script&lang=ts&"
export * from "./topChartAndTable.vue?vue&type=script&lang=ts&"
import style0 from "./topChartAndTable.vue?vue&type=style&index=0&id=0840fae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840fae0",
  null
  
)

export default component.exports